<template>
  <div class="has-shadow position-relative">
    <!--<span class="day-to-go day-to-go--cancelled" v-if="reservation.IsCancelled">Cancelled</span>-->
    <span class="day-to-go">
      <span v-if="booking.DaysToGo == 0">Today</span>
      <span v-if="booking.DaysToGo < 0"
        >{{ -booking.DaysToGo }} days to go!</span
      >
      <span v-if="booking.DaysToGo > 0">{{ booking.DaysToGo }} days ago!</span>
    </span>
    <div class="row">
      <div class="col-xl-7">
        <div class="stay-booking-gallery">
          <single-image-gallery v-bind:images="images"></single-image-gallery>
        </div>
      </div>
      <div class="col-xl-11 g-0">
        <div class="w-100 h-100 p-4">
          <h3 class="mb-2">
            {{ formatDate(booking.Date) }}
          </h3>

          <h4 class="mb-2" v-if="booking?.Item?.Package?.DisplayName">
            <strong>Spa Day:</strong> {{ booking.Item?.Package?.DisplayName }}
          </h4>
          <h4 class="mb-3">
            Confirmation number: {{ booking.Item.ConfirmationId }}
          </h4>

          <div class="row">
            <div
              class="col-xl-24 mb-2 d-flex justify-content-between"
              v-for="(client, index) in booking.Item.Clients"
              v-bind:key="client.Id"
            >
              <span class="w-100" v-if="booking.Item.Clients.length > 1">
                <span
                  class="stay-info-label d-inline-block"
                  style="margin-right: 10px"
                  >Guest {{ index + 1 }}:</span
                >
                {{ client.Title }} {{ client.FirstName }} {{ client.LastName }}
              </span>
              <span class="w-100" v-else>
                <span
                  class="stay-info-label d-inline-block"
                  style="margin-right: 10px"
                  >Guest:</span
                >
                {{ client.Title }} {{ client.FirstName }} {{ client.LastName }}
              </span>
            </div>
            <div
              class="col-xl-12 mb-2 d-flex justify-content-between"
              v-if="booking?.Item?.Package == null"
            >
              <span class="w-100"
                ><span class="stay-info-label d-inline-block"
                  >Total Treatments:</span
                >
                {{ booking.Item.Items.length }}</span
              >
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-6">
        <div class="d-flex flex-column justify-content-end w-100 h-100">
          <div class="flex-grow-1 p-4 account-pricing-detail">
            <span class="total-label">Total</span>
            <span class="total-amount"
              >&pound;{{ priceFormatted(booking.Item.CalculatedAmount) }}</span
            >
          </div>

          <router-link
            class="mb-0 btn btn--continue btn-account-action btn--slate-blue btn--block"
            v-bind:to="{
              name: 'account_spa_booking',
              params: { id: booking.Id },
            }"
          >
            Details
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SingleImageGallery from "@/shared/components/SingleImageGallery.vue";
import { accountStore } from "../store/index";

export default {
  name: "AccountSpaBookingPanel",
  props: {
    booking: {
      type: Object,
      required: true,
    },
  },
  components: {
    SingleImageGallery,
  },
  computed: {
    configuration() {
      return accountStore.getters.accountConfiguration;
    },
    images() {
      let result = [];
      if (this.configuration?.SpaTreatments?.Treatments != null) {
        for (var ri = 0; ri < this.booking.Item.Items.length; ri++) {
          var item = this.booking.Item.Items[ri];

          let items = this.configuration.SpaTreatments.Treatments[0].Images[0];

          result = result.concat(items);
        }
      }

      return result;
    },
    totalPrice() {
      let total = 0;
      for (var ri = 0; ri < this.booking.Item.Items.length; ri++) {
        total += this.booking.Item.Items[ri].Price;
      }
      return total;
    },
  },
  methods: {
    formatDate(date) {
      return moment(date).format("Do MMMM YYYY");
    },
    formatDateSimple(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    formatGuests(guestCount) {
      let result = "";

      if (guestCount.Adults == 1) {
        result += "1 adult";
      }
      if (guestCount.Adults > 1) {
        result += guestCount.Adults + " adults";
      }

      var totalChildren = guestCount.Children + guestCount.Infants;

      if (guestCount.Adults > 0 && totalChildren > 0) {
        result += " & ";
      }

      if (totalChildren > 0) {
        if (totalChildren == 1) {
          result += "1 child";
        }
        if (totalChildren > 1) {
          result += totalChildren + " children";
        }
      }

      return result;
    },

    priceFormatted(num) {
      if (num % 1 == 0) {
        return num;
      }

      return num.toFixed(2);
    },
  },
};
</script>

<style>
.stay-booking-gallery {
  min-height: 224px;
  height: 100%;
  width: 100%;
}

.stay-info-label {
  font-weight: bold;
}

.day-to-go {
  position: absolute;
  left: -6px;
  top: 10px;
  font-size: 12px;
  background-color: #37513c;
  color: white;
  text-transform: uppercase;
  font-weight: bold;
  padding: 10px 14px;
  z-index: 3;
}

.day-to-go--cancelled {
  background-color: rgb(161, 0, 0);
}

.account-pricing-detail {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.account-pricing-detail .total-label {
  display: block;
  font-family: "Playfair Display";
  font-style: italic;
  font-size: 18px;
}

.account-pricing-detail .total-amount {
  display: block;
  font-family: Montserrat;
  font-weight: bold;
  font-size: 36px;
}

.btn-account-action {
  padding-right: 24px !important;
}

.trip-advisor {
  margin-top: 15px;
  padding-left: 50px;
  background-size: 36px 36px;
  background-repeat: no-repeat;
  background-image: url("@/assets/img/booking/tripadvisor.svg");
}

.trip-advisor span {
  display: block;
}

.trip-advisor span.review {
  text-transform: uppercase;
  font-weight: bold;
}

.account-payment {
  margin-bottom: 2px;
  padding: 5px;
}

.account-payment.paid {
  background-color: rgba(52, 127, 52, 0.15);
}

.account-payment.to-pay {
  background-color: rgba(161, 163, 91, 0.2);
}
</style>
